import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <>
      <style>{styles}</style>
      <footer className="footer">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-logo">
            <span>© 2025 recberry Recruiter Program</span>
          </div>
          <div className="social-profiles">
            <a 
              href="https://cz.linkedin.com/company/recberry" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
            <a 
              href="https://cs-cz.facebook.com/recberry/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Facebook
            </a>
            <a 
              href="https://twitter.com/rec_berry" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              X / twitter
            </a>
          </div>
        </div>
        
        <div className="center-line"></div>
        
        <div className="rights">
          <p>
            ® all rights reserved. designed and developed by{' '}
            <a href="http://abaddion.com" target="_blank" rel="noopener noreferrer">
              abaddion
            </a>
          </p>
        </div>
        
        <div className="business">
          <p>
            recberry s.r.o. | IC: 04972236 | DIC: CZ04972236 | Tupolevova 741,
            Prague 9 Letnany | Incorporated in the Commercial Register kept by
            the City: Court in Prague, Section C, under file No.256441
          </p>
          <p style={{ marginTop: '1rem' }}>
            <Link to="/data" style={{ color: 'var(--orange)', textDecoration: 'none' }}>
              Data Protection Policy
            </Link>
          </p>
        </div>
      </div>
      </footer>
    </>
  );
}

// CSS styles (these should already be in your index.css from the original code)
const styles = `
.footer {
  background: var(--dark);
  color: var(--white);
  padding: 2rem 0;
  margin-top: auto; /* This pushes the footer to the bottom */
  flex-shrink: 0; /* Prevents footer from shrinking */
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-logo span {
  font-family: var(--montserrat);
  font-weight: 500;
  color: var(--white);
}

.social-profiles {
  display: flex;
  gap: 2rem;
}

.social-profiles a {
  color: var(--white);
  text-decoration: none;
  font-family: var(--montserrat);
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.3s ease;
}

.social-profiles a:hover {
  color: var(--orange);
}

.center-line {
  height: 1px;
  background: linear-gradient(to right, #555555, #ffffff);
  margin: 2rem 0;
}

.rights {
  text-align: center;
  color: var(--gray);
  margin-bottom: 1rem;
  font-family: var(--raleway);
  font-size: 0.875rem;
}

.rights a {
  color: var(--orange);
  text-decoration: none;
  transition: color 0.3s ease;
}

.rights a:hover {
  color: var(--white);
}

.business {
  text-align: center;
  color: var(--gray);
  font-size: 0.75rem;
  font-family: var(--raleway);
  line-height: 1.5;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-top {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .social-profiles {
    gap: 1rem;
  }
  
  .business {
    font-size: 0.7rem;
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 1.5rem 0;
  }
  
  .footer-content {
    padding: 0 15px;
  }
  
  .social-profiles {
    flex-direction: row;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .business {
    font-size: 0.65rem;
  }
}
`;

export default Footer;